import styled from 'styled-components';

const Wrapper = styled.section`
  border-radius: var(--border-radius);
  width: 100%;
  background: var(--background-secondary-color);
  padding: 3rem 2rem 4rem;
  h3 {
    margin-top: 0;
  }
  .form {
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    max-width: 100%;
    width: 100%;
  }
  .form-title {
    margin-bottom: 2rem;
  }
  .form-row {
    margin-bottom: 0;
  }
  .form-center {
    display: grid;
    row-gap: 1rem;
  }
  /* .form-input, */
  .form-textarea {
    padding: 10px;
    border: 1px solid var(--grey-500);
    border-radius: var(--borderRadius);
    width: 100%;
    font-size: 1rem;
    transition: all 0.3s ease;
  }
  .form-textarea {
    min-height: 100px;
    resize: vertical;
  }
  .form-center button {
    align-self: end;
    height: 35px;
    margin-top: 1rem;
  }
  .btn-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1rem;
    align-self: flex-end;
    margin-top: 0.5rem;
    button {
      height: 35px;
    }
  }
  .clear-btn {
    background: var(--grey-500);
  }
  .clear-btn:hover {
    background: var(--black);
  }

  @media (min-width: 992px) {
    .form-center {
      grid-template-columns: 1fr 1fr;
      align-items: stretch;
      column-gap: 3rem;
      display: grid;
      row-gap: 2rem;
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
    }
    .btn-container {
      margin-top: 0;
    }
  }
  @media (min-width: 1120px) {
    .form-center {
      grid-template-columns: 1fr 1fr 1fr;
    }
    .form-center button {
      margin-top: 0;
    }
  }
  .form-container.select {
    padding: 10px; /* adjust as needed */
  }
  .form-row select {
    padding: 0 10px; /* adjust as needed */
  }
  .clear-btn {
    background: var(--grey-500);
  }
  .clear-btn:hover {
    background: var(--black);
  }
`;

export default Wrapper;
